// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.counter-bubble__counter[data-v-573bab89]{max-width:initial}`, "",{"version":3,"sources":["webpack://./src/components/NavigationMailbox.vue"],"names":[],"mappings":"AACA,0CACC,iBAAA","sourcesContent":["\n.counter-bubble__counter {\n\tmax-width: initial;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
